import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import useCssVars from './use-css-vars';
import { NavContent } from './nav-content';
import { COMPONENTS } from '@theme/admin';

export const MobileNav = (props) => {
  const { open, onClose, sections = [], loading = false } = props;
  const cssVars = useCssVars();

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            ...cssVars,
            backgroundColor: 'var(--nav-bg)',
            color: 'var(--nav-color)',
            width: COMPONENTS.MOBILE_NAV_WIDTH,
          },
        },
      }}
      variant="temporary"
    >
      <NavContent sections={sections} loading={loading} />
    </Drawer>
  );
};

MobileNav.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  sections: PropTypes.array,
  loading: PropTypes.bool,
};
